import React from "react";
import Article from "../../components/Article";
import ImageBanner from "../../components/ImageBanner";

export default function Article1() {
    return (
        <Article 
            title={"Picture ancient ruins surrounded by remnants of Minoan architecture"}
            featuredImage={'/images/moodboard_article_1_featured_image.jpg'}
            content={
                <>
                    <div className="row columns-55-45">
                        <div className="column">
                            <p>Picture ancient ruins surrounded by remnants of Minoan architecture, with a warm Mediterranean sun casting shadows on the weathered stones. The air is filled with a sense of history and mystery.</p>
                        </div>
                        <ImageBanner text={"“Picture ancient ruins surrounded by remnants of Minoan architecture”"} image={'/images/art/Snapseed.jpeg'} />
                    </div>
                </>
            }
        />
    );
}